import { MarcLabel, MarcLabelFromJSON } from '@/api'
import { merge } from 'lodash'

export interface FirstMarcLabel extends MarcLabel {
  secondMarcLabels: MarcLabel[]
}

export function FirstMarcLabelFromJSON(json: any): FirstMarcLabel {
  const marcLabel = MarcLabelFromJSON(json)
  const secondMarcLabels = json.second_marc_labels.map(MarcLabelFromJSON)
  return merge(marcLabel, {
    secondMarcLabels
  })
}
